export default __webpack_public_path__ + "static/media/office_web-md@1x.9e3862fe.webp";